import xhr from './xhrFactory'
import i18next from 'i18next'
import { ConvertLangCode } from '../helpers/convert-lang-code'
/**
 * Get the waiver content associated with a particular slug
 * @async
 * @param {string} slug
 * @returns {Promise<import('./WaiverContentDto').WaiverIntegrationContentDto>}
 */
async function getMetadata(slug, lang, waiverDataId) {
  lang = lang || i18next.language

  const urlString = waiverDataId
    ? `/member/customer-waiver/operator-content/slug/${slug}?lng=${ConvertLangCode(lang)}&waiverDataId=${waiverDataId}`
    : `/member/customer-waiver/operator-content/slug/${slug}?lng=${ConvertLangCode(lang)}`
  const result = await xhr().get(urlString)
  return result.data
}

/**
 * Get a signed url to upload waiver's image
 * @async
 * @param {string} waiverId
 * @param {string} firstName
 * @param {string} lastName
 * @param {string} suffix Used when the image upload will be divided into multiple parts.
 * @param {object} headers
 * @returns {Promise<string>}
 */

async function getSignedUrlForPut(waiverId, firstName, lastName, suffix, headers) {
  const result = await xhr().get(
    `/member/customer-waiver/image-upload-url?waiverId=${waiverId}&firstName=${firstName}&lastName=${lastName}&suffix=${suffix}`,
    {
      headers: headers
    }
  )
  return result.data
}

/**
 * Submit a completed customer waiver
 * @async
 * @param {import('./CustomerWaiverIntegrationDto').CustomerWaiverIntegrationDto} data
 * @param {*} headers
 * @returns {Promise<any>}
 */
async function postWaiver(data, headers) {
  const result = await xhr().post(`/member/customer-waiver?lng=${ConvertLangCode(i18next.language)}`, data, { headers })
  return result
}

const waivers = {
  getMetadata: getMetadata,
  postWaiver: postWaiver,
  getSignedUrlForPut: getSignedUrlForPut
}
export default waivers
